export enum AddressStorageKey {
  RECENT_SEARCHES = 'recentSearches',
}
